<template>
  <div id="shadows-page" class="page-wrapper">
    <h1>Shadows</h1>

    <section>
      <h2>Neutral Shadows</h2>
      <div class="section-wrapper">
        <div class="shadow-grid">
          <div v-for="size in ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl']" :key="size" class="shadow-box" :class="`shadow-neutral-${size}`">
            <p>{{ `$shadow-neutral-${size}` }}</p>
          </div>
        </div>
        <div class="shadow-grid">
          <div v-for="size in ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl']" :key="size" class="shadow-box" :class="`shadow-neutral-up-${size}`">
            <p>{{ `$shadow-neutral-up-${size}` }}</p>
          </div>
        </div>
        <div class="shadow-grid">
          <div v-for="size in ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl']" :key="size" class="shadow-box" :class="`shadow-neutral-right-${size}`">
            <p>{{ `$shadow-neutral-right-${size}` }}</p>
          </div>
        </div>
        <div class="shadow-grid">
          <div v-for="size in ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl']" :key="size" class="shadow-box" :class="`shadow-neutral-left-${size}`">
            <p>{{ `$shadow-neutral-left-${size}` }}</p>
          </div>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Primary Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box primary-bg"
             :class="`shadow-colored-primary-${size}`">
          <p>{{ `$shadow-colored-primary-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Secondary Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box secondary-bg"
             :class="`shadow-colored-secondary-${size}`">
          <p>{{ `$shadow-colored-secondary-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Tertiary Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box tertiary-bg"
             :class="`shadow-colored-tertiary-${size}`">
          <p>{{ `$shadow-colored-tertiary-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Green Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-green-bg"
             :class="`shadow-colored-semantic-green-${size}`">
          <p>{{ `$shadow-colored-semantic-green-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Red Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-red-bg"
             :class="`shadow-colored-semantic-red-${size}`">
          <p>{{ `$shadow-colored-semantic-red-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Status Critical Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box status-critical-bg"
             :class="`shadow-colored-status-critical-${size}`">
          <p>{{ `$shadow-colored-status-critical-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Status Positive Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box status-positive-bg"
             :class="`shadow-colored-status-positive-${size}`">
          <p>{{ `$shadow-colored-status-positive-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Status Warning Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box status-warning-bg"
             :class="`shadow-colored-status-warning-${size}`">
          <p>{{ `$shadow-colored-status-warning-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Status In Progress Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box status-in-progress-bg"
             :class="`shadow-colored-status-in-progress-${size}`">
          <p>{{ `$shadow-colored-status-in-progress-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Yellow Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-yellow-bg"
             :class="`shadow-colored-semantic-yellow-${size}`">
          <p>{{ `$shadow-colored-semantic-yellow-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Violet Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-violet-bg"
             :class="`shadow-colored-semantic-violet-${size}`">
          <p>{{ `$shadow-colored-semantic-violet-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Pink Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-pink-bg"
             :class="`shadow-colored-semantic-pink-${size}`">
          <p>{{ `$shadow-colored-semantic-pink-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Blue Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-blue-bg"
             :class="`shadow-colored-semantic-blue-${size}`">
          <p>{{ `$shadow-colored-semantic-blue-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Bluegreen Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-bluegreen-bg"
             :class="`shadow-colored-semantic-bluegreen-${size}`">
          <p>{{ `$shadow-colored-semantic-bluegreen-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Semantic Orange Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box semantic-orange-bg"
             :class="`shadow-colored-semantic-orange-${size}`">
          <p>{{ `$shadow-colored-semantic-orange-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored Status Neutral Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box status-neutral-bg"
             :class="`shadow-colored-status-neutral-${size}`">
          <p>{{ `$shadow-colored-status-neutral-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Colored AI Shadows</h2>
      <div class="shadow-grid">
        <div v-for="size in ['md', 'lg', 'xl', '2xl', '3xl', '4xl']"
             :key="size"
             class="shadow-box ai-bg"
             :class="`shadow-colored-ai-${size}`">
          <p>{{ `$shadow-colored-ai-${size}` }}</p>
        </div>
      </div>
    </section>

    <section>
      <h2>Special Shadows</h2>
      <div class="shadow-grid">
        <div class="shadow-box shadow-sidebar-left">
          <p>{{ `$shadow-sidebar-left` }}</p>
        </div>
        <div class="shadow-box shadow-menu-bottom">
          <p>{{ `$shadow-menu-bottom` }}</p>
        </div>
        <div class="shadow-box shadow-navbar-bottom">
          <p>{{ `$shadow-navbar-bottom` }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'ShadowsPage'
}
</script>

<style lang="scss">
@import '../../../../../lib/design-token/shadow-token.scss';
@import '../../../../../lib/design-token/color-token.scss';

#shadows-page {
  display: flex;
  flex-direction: column;

  code {
    font-size: 14px;
    color: $color-cool-grey-700;
  }

  section {
    padding-bottom: 48px;

    .section-wrapper {
      display: flex;
      flex-direction: column;
      gap: 60px;
    }
  }

  .shadow-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 60px;

    p {
      font-size: 12px;
      color: $color-cool-grey-500;
    }
  }

  .shadow-box {
    // border: 1px solid $color-cool-grey-200;
    border-radius: 8px;
    padding: 1.5rem;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    // Neutral shadows
    &.shadow-neutral-xs { box-shadow: $shadow-neutral-xs; }
    &.shadow-neutral-sm { box-shadow: $shadow-neutral-sm; }
    &.shadow-neutral-md { box-shadow: $shadow-neutral-md; }
    &.shadow-neutral-lg { box-shadow: $shadow-neutral-lg; }
    &.shadow-neutral-xl { box-shadow: $shadow-neutral-xl; }
    &.shadow-neutral-2xl { box-shadow: $shadow-neutral-2xl; }
    &.shadow-neutral-3xl { box-shadow: $shadow-neutral-3xl; }
    &.shadow-neutral-4xl { box-shadow: $shadow-neutral-4xl; }
    &.shadow-neutral-up-xs { box-shadow: $shadow-neutral-up-xs; }
    &.shadow-neutral-up-sm { box-shadow: $shadow-neutral-up-sm; }
    &.shadow-neutral-up-md { box-shadow: $shadow-neutral-up-md; }
    &.shadow-neutral-up-lg { box-shadow: $shadow-neutral-up-lg; }
    &.shadow-neutral-up-xl { box-shadow: $shadow-neutral-up-xl; }
    &.shadow-neutral-up-2xl { box-shadow: $shadow-neutral-up-2xl; }
    &.shadow-neutral-up-3xl { box-shadow: $shadow-neutral-up-3xl; }
    &.shadow-neutral-up-4xl { box-shadow: $shadow-neutral-up-4xl; }
    &.shadow-neutral-right-xs { box-shadow: $shadow-neutral-right-xs; }
    &.shadow-neutral-right-sm { box-shadow: $shadow-neutral-right-sm; }
    &.shadow-neutral-right-md { box-shadow: $shadow-neutral-right-md; }
    &.shadow-neutral-right-lg { box-shadow: $shadow-neutral-right-lg; }
    &.shadow-neutral-right-xl { box-shadow: $shadow-neutral-right-xl; }
    &.shadow-neutral-right-2xl { box-shadow: $shadow-neutral-right-2xl; }
    &.shadow-neutral-right-3xl { box-shadow: $shadow-neutral-right-3xl; }
    &.shadow-neutral-right-4xl { box-shadow: $shadow-neutral-right-4xl; }
    &.shadow-neutral-left-xs { box-shadow: $shadow-neutral-left-xs; }
    &.shadow-neutral-left-sm { box-shadow: $shadow-neutral-left-sm; }
    &.shadow-neutral-left-md { box-shadow: $shadow-neutral-left-md; }
    &.shadow-neutral-left-lg { box-shadow: $shadow-neutral-left-lg; }
    &.shadow-neutral-left-xl { box-shadow: $shadow-neutral-left-xl; }
    &.shadow-neutral-left-2xl { box-shadow: $shadow-neutral-left-2xl; }
    &.shadow-neutral-left-3xl { box-shadow: $shadow-neutral-left-3xl; }
    &.shadow-neutral-left-4xl { box-shadow: $shadow-neutral-left-4xl; }

    // Colored shadows - Primary
    &.shadow-colored-primary-md { box-shadow: $shadow-colored-primary-md; }
    &.shadow-colored-primary-lg { box-shadow: $shadow-colored-primary-lg; }
    &.shadow-colored-primary-xl { box-shadow: $shadow-colored-primary-xl; }
    &.shadow-colored-primary-2xl { box-shadow: $shadow-colored-primary-2xl; }
    &.shadow-colored-primary-3xl { box-shadow: $shadow-colored-primary-3xl; }
    &.shadow-colored-primary-4xl { box-shadow: $shadow-colored-primary-4xl; }

    // Colored shadows - Secondary
    &.shadow-colored-secondary-md { box-shadow: $shadow-colored-secondary-md; }
    &.shadow-colored-secondary-lg { box-shadow: $shadow-colored-secondary-lg; }
    &.shadow-colored-secondary-xl { box-shadow: $shadow-colored-secondary-xl; }
    &.shadow-colored-secondary-2xl { box-shadow: $shadow-colored-secondary-2xl; }
    &.shadow-colored-secondary-3xl { box-shadow: $shadow-colored-secondary-3xl; }
    &.shadow-colored-secondary-4xl { box-shadow: $shadow-colored-secondary-4xl; }

    // Colored shadows - Tertiary
    &.shadow-colored-tertiary-md { box-shadow: $shadow-colored-tertiary-md; }
    &.shadow-colored-tertiary-lg { box-shadow: $shadow-colored-tertiary-lg; }
    &.shadow-colored-tertiary-xl { box-shadow: $shadow-colored-tertiary-xl; }
    &.shadow-colored-tertiary-2xl { box-shadow: $shadow-colored-tertiary-2xl; }
    &.shadow-colored-tertiary-3xl { box-shadow: $shadow-colored-tertiary-3xl; }
    &.shadow-colored-tertiary-4xl { box-shadow: $shadow-colored-tertiary-4xl; }

    // Colored shadows - Semantic Green
    &.shadow-colored-semantic-green-md { box-shadow: $shadow-colored-semantic-green-md; }
    &.shadow-colored-semantic-green-lg { box-shadow: $shadow-colored-semantic-green-lg; }
    &.shadow-colored-semantic-green-xl { box-shadow: $shadow-colored-semantic-green-xl; }
    &.shadow-colored-semantic-green-2xl { box-shadow: $shadow-colored-semantic-green-2xl; }
    &.shadow-colored-semantic-green-3xl { box-shadow: $shadow-colored-semantic-green-3xl; }
    &.shadow-colored-semantic-green-4xl { box-shadow: $shadow-colored-semantic-green-4xl; }

    // Colored shadows - Semantic Red
    &.shadow-colored-semantic-red-md { box-shadow: $shadow-colored-semantic-red-md; }
    &.shadow-colored-semantic-red-lg { box-shadow: $shadow-colored-semantic-red-lg; }
    &.shadow-colored-semantic-red-xl { box-shadow: $shadow-colored-semantic-red-xl; }
    &.shadow-colored-semantic-red-2xl { box-shadow: $shadow-colored-semantic-red-2xl; }
    &.shadow-colored-semantic-red-3xl { box-shadow: $shadow-colored-semantic-red-3xl; }
    &.shadow-colored-semantic-red-4xl { box-shadow: $shadow-colored-semantic-red-4xl; }

    // Colored shadows - Semantic Critical
    &.shadow-colored-status-critical-md { box-shadow: $shadow-colored-status-critical-md; }
    &.shadow-colored-status-critical-lg { box-shadow: $shadow-colored-status-critical-lg; }
    &.shadow-colored-status-critical-xl { box-shadow: $shadow-colored-status-critical-xl; }
    &.shadow-colored-status-critical-2xl { box-shadow: $shadow-colored-status-critical-2xl; }
    &.shadow-colored-status-critical-3xl { box-shadow: $shadow-colored-status-critical-3xl; }
    &.shadow-colored-status-critical-4xl { box-shadow: $shadow-colored-status-critical-4xl; }

    // Colored shadows - Semantic Positive
    &.shadow-colored-status-positive-md { box-shadow: $shadow-colored-status-positive-md; }
    &.shadow-colored-status-positive-lg { box-shadow: $shadow-colored-status-positive-lg; }
    &.shadow-colored-status-positive-xl { box-shadow: $shadow-colored-status-positive-xl; }
    &.shadow-colored-status-positive-2xl { box-shadow: $shadow-colored-status-positive-2xl; }
    &.shadow-colored-status-positive-3xl { box-shadow: $shadow-colored-status-positive-3xl; }
    &.shadow-colored-status-positive-4xl { box-shadow: $shadow-colored-status-positive-4xl; }

    // Colored shadows - Semantic Warning
    &.shadow-colored-status-warning-md { box-shadow: $shadow-colored-status-warning-md; }
    &.shadow-colored-status-warning-lg { box-shadow: $shadow-colored-status-warning-lg; }
    &.shadow-colored-status-warning-xl { box-shadow: $shadow-colored-status-warning-xl; }
    &.shadow-colored-status-warning-2xl { box-shadow: $shadow-colored-status-warning-2xl; }
    &.shadow-colored-status-warning-3xl { box-shadow: $shadow-colored-status-warning-3xl; }
    &.shadow-colored-status-warning-4xl { box-shadow: $shadow-colored-status-warning-4xl; }

    // Colored shadows - Semantic Yellow
    &.shadow-colored-semantic-yellow-md { box-shadow: $shadow-colored-semantic-yellow-md; }
    &.shadow-colored-semantic-yellow-lg { box-shadow: $shadow-colored-semantic-yellow-lg; }
    &.shadow-colored-semantic-yellow-xl { box-shadow: $shadow-colored-semantic-yellow-xl; }
    &.shadow-colored-semantic-yellow-2xl { box-shadow: $shadow-colored-semantic-yellow-2xl; }
    &.shadow-colored-semantic-yellow-3xl { box-shadow: $shadow-colored-semantic-yellow-3xl; }
    &.shadow-colored-semantic-yellow-4xl { box-shadow: $shadow-colored-semantic-yellow-4xl; }

    // Colored shadows - Semantic In Progress
    &.shadow-colored-status-in-progress-md { box-shadow: $shadow-colored-status-in-progress-md; }
    &.shadow-colored-status-in-progress-lg { box-shadow: $shadow-colored-status-in-progress-lg; }
    &.shadow-colored-status-in-progress-xl { box-shadow: $shadow-colored-status-in-progress-xl; }
    &.shadow-colored-status-in-progress-2xl { box-shadow: $shadow-colored-status-in-progress-2xl; }
    &.shadow-colored-status-in-progress-3xl { box-shadow: $shadow-colored-status-in-progress-3xl; }
    &.shadow-colored-status-in-progress-4xl { box-shadow: $shadow-colored-status-in-progress-4xl; }

    // Colored shadows - Semantic Blue
    &.shadow-colored-semantic-blue-md { box-shadow: $shadow-colored-semantic-blue-md; }
    &.shadow-colored-semantic-blue-lg { box-shadow: $shadow-colored-semantic-blue-lg; }
    &.shadow-colored-semantic-blue-xl { box-shadow: $shadow-colored-semantic-blue-xl; }
    &.shadow-colored-semantic-blue-2xl { box-shadow: $shadow-colored-semantic-blue-2xl; }
    &.shadow-colored-semantic-blue-3xl { box-shadow: $shadow-colored-semantic-blue-3xl; }
    &.shadow-colored-semantic-blue-4xl { box-shadow: $shadow-colored-semantic-blue-4xl; }

    // Colored shadows - Semantic Informing
    &.shadow-colored-status-informing-md { box-shadow: $shadow-colored-status-informing-md; }
    &.shadow-colored-status-informing-lg { box-shadow: $shadow-colored-status-informing-lg; }
    &.shadow-colored-status-informing-xl { box-shadow: $shadow-colored-status-informing-xl; }
    &.shadow-colored-status-informing-2xl { box-shadow: $shadow-colored-status-informing-2xl; }
    &.shadow-colored-status-informing-3xl { box-shadow: $shadow-colored-status-informing-3xl; }
    &.shadow-colored-status-informing-4xl { box-shadow: $shadow-colored-status-informing-4xl; }

    // Colored shadows - Semantic Violet
    &.shadow-colored-semantic-violet-md { box-shadow: $shadow-colored-semantic-violet-md; }
    &.shadow-colored-semantic-violet-lg { box-shadow: $shadow-colored-semantic-violet-lg; }
    &.shadow-colored-semantic-violet-xl { box-shadow: $shadow-colored-semantic-violet-xl; }
    &.shadow-colored-semantic-violet-2xl { box-shadow: $shadow-colored-semantic-violet-2xl; }
    &.shadow-colored-semantic-violet-3xl { box-shadow: $shadow-colored-semantic-violet-3xl; }
    &.shadow-colored-semantic-violet-4xl { box-shadow: $shadow-colored-semantic-violet-4xl; }

    // Colored shadows - Semantic Concerning
    &.shadow-colored-status-concerning-md { box-shadow: $shadow-colored-status-concerning-md; }
    &.shadow-colored-status-concerning-lg { box-shadow: $shadow-colored-status-concerning-lg; }
    &.shadow-colored-status-concerning-xl { box-shadow: $shadow-colored-status-concerning-xl; }
    &.shadow-colored-status-concerning-2xl { box-shadow: $shadow-colored-status-concerning-2xl; }
    &.shadow-colored-status-concerning-3xl { box-shadow: $shadow-colored-status-concerning-3xl; }
    &.shadow-colored-status-concerning-4xl { box-shadow: $shadow-colored-status-concerning-4xl; }

    // Colored shadows - Semantic Pink
    &.shadow-colored-semantic-pink-md { box-shadow: $shadow-colored-semantic-pink-md; }
    &.shadow-colored-semantic-pink-lg { box-shadow: $shadow-colored-semantic-pink-lg; }
    &.shadow-colored-semantic-pink-xl { box-shadow: $shadow-colored-semantic-pink-xl; }
    &.shadow-colored-semantic-pink-2xl { box-shadow: $shadow-colored-semantic-pink-2xl; }
    &.shadow-colored-semantic-pink-3xl { box-shadow: $shadow-colored-semantic-pink-3xl; }
    &.shadow-colored-semantic-pink-4xl { box-shadow: $shadow-colored-semantic-pink-4xl; }

    // Colored shadows - Semantic Bluegreen
    &.shadow-colored-semantic-bluegreen-md { box-shadow: $shadow-colored-semantic-bluegreen-md; }
    &.shadow-colored-semantic-bluegreen-lg { box-shadow: $shadow-colored-semantic-bluegreen-lg; }
    &.shadow-colored-semantic-bluegreen-xl { box-shadow: $shadow-colored-semantic-bluegreen-xl; }
    &.shadow-colored-semantic-bluegreen-2xl { box-shadow: $shadow-colored-semantic-bluegreen-2xl; }
    &.shadow-colored-semantic-bluegreen-3xl { box-shadow: $shadow-colored-semantic-bluegreen-3xl; }
    &.shadow-colored-semantic-bluegreen-4xl { box-shadow: $shadow-colored-semantic-bluegreen-4xl; }

    // Colored shadows - Status Neutral
    &.shadow-colored-status-neutral-md { box-shadow: $shadow-colored-status-neutral-md; }
    &.shadow-colored-status-neutral-lg { box-shadow: $shadow-colored-status-neutral-lg; }
    &.shadow-colored-status-neutral-xl { box-shadow: $shadow-colored-status-neutral-xl; }
    &.shadow-colored-status-neutral-2xl { box-shadow: $shadow-colored-status-neutral-2xl; }
    &.shadow-colored-status-neutral-3xl { box-shadow: $shadow-colored-status-neutral-3xl; }
    &.shadow-colored-status-neutral-4xl { box-shadow: $shadow-colored-status-neutral-4xl; }

    // Colored shadows - Semantic Orange
    &.shadow-colored-semantic-orange-md { box-shadow: $shadow-colored-semantic-orange-md; }
    &.shadow-colored-semantic-orange-lg { box-shadow: $shadow-colored-semantic-orange-lg; }
    &.shadow-colored-semantic-orange-xl { box-shadow: $shadow-colored-semantic-orange-xl; }
    &.shadow-colored-semantic-orange-2xl { box-shadow: $shadow-colored-semantic-orange-2xl; }
    &.shadow-colored-semantic-orange-3xl { box-shadow: $shadow-colored-semantic-orange-3xl; }
    &.shadow-colored-semantic-orange-4xl { box-shadow: $shadow-colored-semantic-orange-4xl; }

    // Colored shadows - AI
    &.shadow-colored-ai-md { box-shadow: $shadow-colored-ai-md; }
    &.shadow-colored-ai-lg { box-shadow: $shadow-colored-ai-lg; }
    &.shadow-colored-ai-xl { box-shadow: $shadow-colored-ai-xl; }
    &.shadow-colored-ai-2xl { box-shadow: $shadow-colored-ai-2xl; }
    &.shadow-colored-ai-3xl { box-shadow: $shadow-colored-ai-3xl; }
    &.shadow-colored-ai-4xl { box-shadow: $shadow-colored-ai-4xl; }

    // Special shadows
    &.shadow-sidebar-right { box-shadow: $shadow-sidebar-right; }
    &.shadow-sidebar-left { box-shadow: $shadow-sidebar-left; }
    &.shadow-menu-bottom { box-shadow: $shadow-menu-bottom; }
    &.shadow-navbar-bottom { box-shadow: $shadow-navbar-bottom; }
  }
}
</style>
